import { useNavigate } from 'react-router-dom';

import useUsers from '../../../api/useUsers';
import { useLogin } from '../../../hooks/useLogin';

import { EProfileDropdownItems } from './constants';
import { useSupportHandler } from './useSupportHandler';

export const useProfileDropdownActions = () => {
  const navigate = useNavigate();
  const { cleanUserLoginData } = useLogin();
  const { logout } = useUsers({});
  const { onSupportClick } = useSupportHandler();

  const onProfileClick = () => navigate(`profile/personal`);

  const onLogoutClick = async () => {
    await cleanUserLoginData();
    await logout.mutate();
  };

  return {
    [EProfileDropdownItems.PROFILE]: onProfileClick,
    [EProfileDropdownItems.SUPPORT]: onSupportClick,
    [EProfileDropdownItems.LOGOUT]: onLogoutClick
  };
};
